import {
    ArrowDownTrayIcon,
    ArrowUturnLeftIcon,
    BellAlertIcon,
    PaperAirplaneIcon,
    PencilSquareIcon,
    TrashIcon,
} from "@heroicons/react/24/outline";
import { PrimaryButton } from "../../../../../../components/general/PrimaryButton.tsx";
import { SecondaryButton } from "../../../../../../components/general/SecondaryButton.tsx";
import type {SalesInvoiceDisplayStatus} from "../../../../../../generated/enums.ts";

interface Props {
    displayStatus: SalesInvoiceDisplayStatus;
    hasBeenSent: boolean;
    isDownloadingPdf: boolean;
    canCredit: boolean;
    canEditDraft: boolean;
    onSend: () => void;
    onSendReminder: () => void;
    onDownloadPdf: () => void;
    onEditDraft: () => void;
    onDiscardDraft: () => void;
    onCredit: () => void;
}

export function InvoiceActionsCard({
    displayStatus,
    hasBeenSent,
    isDownloadingPdf,
    canCredit,
    canEditDraft,
    onSend,
    onSendReminder,
    onDownloadPdf,
    onEditDraft,
    onDiscardDraft,
    onCredit,
}: Props) {
    const isUnpaid = displayStatus === "outstanding" || displayStatus === "overdue";

    return (
        <div className="p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Acties</h3>
            {displayStatus === "draft" ? (
                <div className="flex flex-col gap-3">
                    <PrimaryButton
                        className="w-full justify-center"
                        title="Definitief maken & versturen"
                        icon={PaperAirplaneIcon}
                        onClick={onSend}
                    />
                    {canEditDraft && (
                        <SecondaryButton
                            className="w-full justify-center"
                            title="Concept bewerken"
                            icon={PencilSquareIcon}
                            onClick={onEditDraft}
                        />
                    )}
                    <SecondaryButton
                        className="w-full justify-center"
                        title="Concept verwijderen"
                        icon={TrashIcon}
                        onClick={onDiscardDraft}
                    />
                    <SecondaryButton
                        className="w-full justify-center"
                        title="Download PDF"
                        icon={ArrowDownTrayIcon}
                        loading={isDownloadingPdf}
                        onClick={onDownloadPdf}
                    />
                </div>
            ) : (
                <div className="flex flex-col gap-3">
                    <PrimaryButton
                        className="w-full justify-center"
                        title={hasBeenSent ? "Opnieuw versturen" : "Verstuur per e-mail"}
                        icon={PaperAirplaneIcon}
                        onClick={onSend}
                    />
                    {isUnpaid && (
                        <SecondaryButton
                            className="w-full justify-center"
                            title="Herinnering sturen"
                            icon={BellAlertIcon}
                            onClick={onSendReminder}
                        />
                    )}
                    {canCredit && (
                        <SecondaryButton
                            className="w-full justify-center bg-gray-100"
                            title="Crediteer factuur"
                            icon={ArrowUturnLeftIcon}
                            onClick={onCredit}
                        />
                    )}
                    <SecondaryButton
                        className="w-full justify-center"
                        title="Download PDF"
                        icon={ArrowDownTrayIcon}
                        loading={isDownloadingPdf}
                        onClick={onDownloadPdf}
                    />
                </div>
            )}
        </div>
    );
}
